import { KeyboardEvent } from 'react';

export const isInputSubmitAttempt = (event: KeyboardEvent) =>
  event.key === 'Enter' && !event.shiftKey && !event.ctrlKey;
